import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { MarketdateMeterreadingComponent } from './marketdate-meterreading.component';
import { MarketdateMeterreadingDetailComponent } from './marketdate-meterreading-detail.component';
import { MarketdateMeterreadingPopupComponent } from './marketdate-meterreading-dialog.component';
import { MarketdateMeterreadingDeletePopupComponent } from './marketdate-meterreading-delete-dialog.component';

import { Principal } from '../../shared';

export const marketdateMeterreadingRoute: Routes = [
  {
    path: 'marketdate-meterreading',
    component: MarketdateMeterreadingComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateMeterreading.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'marketdate-meterreading/:id',
    component: MarketdateMeterreadingDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateMeterreading.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const marketdateMeterreadingPopupRoute: Routes = [
  {
    path: 'marketdate-meterreading-new',
    component: MarketdateMeterreadingPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateMeterreading.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate-meterreading/:id/edit',
    component: MarketdateMeterreadingPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateMeterreading.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate-meterreading/:id/delete',
    component: MarketdateMeterreadingDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateMeterreading.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-meterreading/marketdate-meterreading.route.ts